var validate = require('../helpers/validate');

var _require = require('../utils/utils'),
    isPlainObject = _require.isPlainObject;

module.exports = function (instance) {
  return function (id, revision) {
    if (isPlainObject(id)) {
      revision = id.revision;
      id = id.id;
    }

    validate.entityId(id);
    validate.revisionId(revision);
    return "".concat(instance, "/w/index.php?title=Special:EntityData/").concat(id, ".json&oldid=").concat(revision);
  };
};